// File upload configuration
export const FILE_UPLOAD_CONFIG = {
  // Maximum file size in bytes (10MB by default)
  MAX_FILE_SIZE: 10 * 1024 * 1024,
  
  // Allowed file types
  ALLOWED_TYPES: {
    images: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'],
    documents: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
  },
  
  // Get all allowed types as a single array
  getAllowedTypes(): string[] {
    return [...this.ALLOWED_TYPES.images, ...this.ALLOWED_TYPES.documents];
  },
  
  // Get file size in MB for display
  getMaxFileSizeMB(): number {
    return this.MAX_FILE_SIZE / (1024 * 1024);
  }
};